<template>
    <div>
        <Penggajian v-if="islistpenggajian" v-on:listkomisi="showlistkomisi" v-on:listpotongan="showlistpotongan"
                    v-on:listkasbon="showlistkasbon" v-on:showfakturgaji="showFakturGaji" v-on:showhistory="showHistory"/>
        <AddKomisiP v-if="isaddkomisip" v-on:backtolistpenggajian="showlistpenggajian"/>
        <AddPotongan v-if="isaddpotongan" v-on:backtolistpenggajian="showlistpenggajian"/>
        <AddKasbon v-if="isaddkasbon" v-on:backtolistpenggajian="showlistpenggajian"/>
        <AddFakturGaji v-if="isaddfakturgaji" v-on:showlistpenggajian="showlistpenggajian" v-on:showhistory="showHistory"/>
        <RiwayatPembayaran v-if="isHistory" v-on:backtolistpenggajian="showlistpenggajian"  v-on:addpenggajian="showFakturGaji"/>
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        </div>
	    <div id="loadingPage2" style="display: none">
		    <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
	    </div>
        <div v-on:click="closealert" role="alert" id="alert"  class="fix-alert z-index">
            <img class="" style="float: right;width: 16px;height: 16px;color: #155724" src="../assets/icons/close-red.svg" alt="">
            <p class="remove-margin" id="contentAlert"></p>
        </div>
        <div v-on:click="closealertS" role="alert" id="alertS"  class="fix-alert z-index">
            <i class="fa fa-times" id="closeS" aria-hidden="true" style="float: right"></i>
            <p class="remove-margin" id="contentAlertS"></p>
        </div>
    </div>
</template>

<script>
    import Penggajian from "./penggajian/Penggajian";
    import AddKomisiP from "./penggajian/Komisi Penggajian/AddKomisiP";
    import AddPotongan from "./penggajian/Potongan Gaji/AddPotongan";
    import AddKasbon from "./penggajian/Kasbon/AddKasbon";
    import AddFakturGaji from "./AddFakturGaji";
    import RiwayatPembayaran from "./penggajian/Riwayat Pembayaraan/RiwayatPembayaran";
    export default {
        name: "AddPenggajian",
        components: {RiwayatPembayaran, AddFakturGaji, AddKasbon, AddPotongan, AddKomisiP, Penggajian},
        data(){
            return{
                islistpenggajian:false,
                isaddkomisip:false,
                isaddpotongan:false,
                isaddkasbon:false,
                isaddfakturgaji:false,
                isHistory:false,
            }
        },
        mounted(){
            this.showlistpenggajian()
            this.smartTrackingView("penggajian,komisi_dan_kasbon");

        },
        methods:{
            closealert() {
                $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                $('#alert').addClass("alert alert-danger animated fadeOutUp");
                setTimeout(() =>{
                    $('#alert').addClass("display-none")
                }, 2000)

            },

            closealertS() {
                $('#alertS').removeClass("alert alert-success animated fadeInDown show-display");
                $('#alertS').addClass("alert alert-success animated fadeOutUp");
                setTimeout(() =>{
                    $('#alertS').addClass("display-none")
                }, 2000)
            },
            showHistory(){
                this.isHistory=true;
                this.islistpenggajian=false;
                this.isaddkomisip=false;
                this.isaddpotongan = false;
                this.isaddkasbon = false;
                this.isaddfakturgaji = false;
            },
            showlistpenggajian(){
                this.islistpenggajian=true;
                this.isaddkomisip=false;
                this.isaddpotongan = false;
                this.isaddkasbon = false;
                this.isaddfakturgaji = false;
                this.isHistory=false
            },

            showlistkomisi(){
                this.islistpenggajian=false;
                this.isaddkomisip=true;
                this.isaddpotongan = false;
                this.isaddkasbon = false;
                this.isaddfakturgaji = false;
                this.isHistory=false
            },

            showlistpotongan(){
                this.islistpenggajian=false;
                this.isaddkomisip=false;
                this.isaddpotongan = true;
                this.isaddkasbon = false;
                this.isaddfakturgaji = false;
                this.isHistory=false
				window.scrollTo(0,0);
            },

            showlistkasbon(){
                this.islistpenggajian=false;
                this.isaddkomisip=false;
                this.isaddpotongan = false;
                this.isaddkasbon = true;
                this.isaddfakturgaji = false;
                this.isHistory=false
				window.scrollTo(0,0);
            },

            showFakturGaji(){
                this.islistpenggajian=false;
                this.isaddkomisip=false;
                this.isaddpotongan = false;
                this.isaddkasbon = false;
                this.isaddfakturgaji = true;
                this.isHistory=false
            },
        }
    }
</script>

<style scoped>

</style>